import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';
import GithubSlugger from 'github-slugger';

export function pluginAutoLinkHeadings() {
  const slugger = new GithubSlugger();

  return {
    viewerEffect: ({ markdownBody }) => {
      markdownBody.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((el) => {
        if (!el.getAttribute('data-anchor') && el instanceof HTMLElement) {
          el.setAttribute('data-anchor', 'true');
          el.appendChild(
            (() => {
              // <a class="anchor" aria-hidden="" tabindex="-1" href="#项目内跳转"><span class="icon-link">#</span></a>
              const anchor = document.createElement('a');
              anchor.className = 'anchor';
              anchor.setAttribute('aria-hidden', '');
              anchor.setAttribute('tabindex', '-1');
              anchor.href = '#' + slugger.slug(el.innerText);
              const span = document.createElement('span');
              span.className = 'icon-link';
              span.innerText = '#';
              anchor.appendChild(span);
              return anchor;
            })(),
          );
        }
      });
    },
    // rehype: (process) =>
    //   process.use(rehypeAutolinkHeadings, {
    //     behavior: 'append',
    //     properties: {
    //       className: ['anchor'],
    //       ariaHidden: true,
    //       tabIndex: -1,
    //     },
    //     content: {
    //       type: 'element',
    //       tagName: 'span',
    //       properties: {
    //         className: ['icon-link'],
    //       },
    //       children: [{ type: 'text', value: '#' }],
    //     },
    //   }),
  } as BytemdSafeMdxViewerPlugin;
}
